import { Link } from "react-router-dom"

const Button = ({children, className, href, onClick, disabled = false, type = 'button'}) => {
  return (
    href ? <Link to={href} className={`${className} text-center flex items-center justify-center ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`} onClick={onClick}>
        <button className={`${disabled ? 'opacity-50 cursor-not-allowed' : ''}`} type={type} disabled = {disabled}>{children}</button>
    </Link> : <button className={`${className} block`} onClick={onClick}>{children}</button>
  )
}

export default Button